<template>
  <el-dialog
    ref="adduser"
    :title="title"
    top="70px"
    width="700px"
    height="700px"
    :visible.sync="showGpsMap"
    append-to-body
    :show-close="true"
    :close-on-click-modal="true"
    @close="close"
  >
    <el-amap
      v-if="gpsInfo"
      vid="gpsInfo"
      :center="[gpsInfo.longitude,gpsInfo.latitude]"
      style="width: 100%;height:400px;"
      :zoom="10"
      :plugin="gpsPlugins"
    >
      <el-amap-marker :position="[gpsInfo.longitude,gpsInfo.latitude]" />
    </el-amap>
  </el-dialog>
</template>
<script>

export default {
  name: 'GpsMapModal',
  props: {
    title: {
      type: String,
      default: '经纬度'
    }
  },
  data () {
    return {
      gpsInfo: null,
      gpsPlugins: [{
        // pName为必填字段
        pName: 'ToolBar',
        position: "RT",
        liteStyle: true
      }, {
        // pName为必填字段
        pName: 'Scale'
      }],
      showGpsMap: false
    }
  },
  methods: {
    open (gps) {
      this.gpsInfo = {
        longitude: gps.split(',')[0],
        latitude: gps.split(',')[1]
      }
      this.showGpsMap = true
    },
    open2 (longitude, latitude) {
      this.gpsInfo = {
        longitude,
        latitude
      }
      this.showGpsMap = true
    },
    close () {
      this.showGpsMap = false
      this.gpsInfo = null
    }
  }
}
</script>
<style lang="less" scoped>

</style>
